import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import {translate} from "../../../../../components/translate/translate.jsx";

const DayOfWeekContent = ({ data }) => {
    const dow = data?.apply?.by_dow;

    useEffect(() => {
        const values = [];
        const labels = [];

        dow.map((element) => {
           labels.push(translate(element.text));
           values.push(element.qty);
        });

        GraphicUtils.barChart('alarms-dow', values, labels, false);
        ReportUtils.createExportableTable(labels, values, "Alarmes por dia da semana", null, ["Dia da semana", "Quantidade"]);
    }, [dow]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Alarmes por dia da semana</span>
                <div id="alarms-dow"/>
            </div>
        </>
    );
};

export default DayOfWeekContent;